import { Button } from '@/components/atoms/Buttons';

import styles from './ModalFormActions.module.scss';

interface ModalFormActionsProps {
    cancelLabel: string;
    submitLabel: string;
    isSubmitting: boolean;
    /** Holds submit back while the form still waits for data it needs, e.g. the pen list. */
    submitDisabled?: boolean;
    onCancel: () => void;
}

/** Cancel and submit at the bottom of a board modal's form; submit is the form's own button. */
export default function ModalFormActions(props: ModalFormActionsProps) {
    const { cancelLabel, submitLabel, isSubmitting, submitDisabled = false, onCancel } = props;

    return (
        <div className={styles.actions}>
            {isSubmitting && <span className={styles.spinner} aria-hidden="true" />}
            <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
                {cancelLabel}
            </Button>
            <Button variant="primary" type="submit" disabled={isSubmitting || submitDisabled}>
                {submitLabel}
            </Button>
        </div>
    );
}
